<template>
  <div>
    <loading-spinner v-if="showLoading" />

    <!-- Reset Password Form -->
    <div v-if="!resetSuccess">
      <!-- Company Logo -->
      <company-logo />

      <!-- Title -->
      <list-header title="New Password" />

      <!-- Reset Password Form -->
      <div class="p-3 text-start">
        <Form @submit="handleResetPassword" :validation-schema="schema">
          <div>
            <Field
              name="password"
              v-slot="{ handleChange, errorMessage, meta }">
              <input type="hidden" :value="passwordValid = meta.valid" />

              <default-input-field
                type="password"
                placeholder="Enter a new password"
                v-model:value="password"
                @update:value="handleChange"
                :errorValidate="errorMessage"
              />
            </Field>
          </div>

          <div class="mt-3">
            <Field
              name="confirmPassword"
              v-slot="{ handleChange, errorMessage, meta }"
            >
              <input type="hidden" :value="confirmPasswordValid = meta.valid" />

              <default-input-field
                type="password"
                placeholder="Confirm the password again"
                v-model:value="confirmPassword"
                @update:value="handleChange"
                :errorValidate="errorMessage"
              />
            </Field>
          </div>

          <!-- Reset Passowrd Button -->
          <div class="scss-button-position-bottom">
            <default-button title="Submit" type="submit" :disabled="disabledSubmit"/>
          </div>
        </Form>
      </div>
    </div>

    <!-- Booking Done Message -->
    <div v-if="resetSuccess">
      <div class="style-container">
        <div class="px-3 mb-5">
          <div class="style-header scss-bold">Password Reset Successfully!</div>

          <div class="mt-5">
            <img src="@/assets/icons/green-tick.png" class="style-icon" />
          </div>

          <div class="mt-5 text-center scss-small-font">
            Your account is secured with a new password.
            <br />
            Sign in now to proceed.
          </div>
        </div>
      </div>

      <!-- Homepage Button -->
      <div class="scss-button-position-bottom">
        <default-button title="Sign In" @click="goToSignInPage" />
      </div>
    </div>
  </div>
</template>

<script>
import { Form, Field } from "vee-validate";
import * as yup from "yup";
import { useToast } from "vue-toastification";
import { isEmpty } from 'lodash';

import LoadingSpinner from "@/components/LoadingSpinner.vue";
import DefaultInputField from "@/components/input/DefaultInputField.vue";
import { validationRules } from "@/validation/ValidationRules";
import ListHeader from "@/components/ListHeader.vue";
import DefaultButton from "@/components/button/DefaultButton.vue";
import CompanyLogo from "@/components/CompanyLogo.vue";
import { resetPassword, getResetPasswordToken } from "@/services/auth";

export default {
  name: "ResetPassword",
  components: {
    DefaultInputField,
    Form,
    Field,
    ListHeader,
    LoadingSpinner,
    DefaultButton,
    CompanyLogo,
  },
  data() {
    return {
      password: "",
      passwordValid: false,
      confirmPassword: "",
      confirmPasswordValid: false,
      tokenGetPhoneMobile: this.$route.params.id,
      validTokenGetPhoneMobile: false,
      phoneMobile: null,
      tokenResetPassword: null,
      resetSuccess: false,
      showLoading: false,
    };
  },
  computed: {
    schema() {
      return yup.object({
        password: validationRules.password,
        confirmPassword: validationRules.confirmPassword,
      });
    },
    disabledSubmit() {
      const invalidSubmitData =
        isEmpty(this.tokenResetPassword) ||
        !this.passwordValid ||
        !this.confirmPasswordValid;

      return !this.validTokenGetPhoneMobile || invalidSubmitData;
    }
  },
  methods: {
    async handleResetPassword() {
      this.showLoading = true;
      try {
        await resetPassword(
          this.tokenResetPassword,
          this.phoneMobile,
          this.password
        );
        this.resetSuccess = true;
      } catch (error) {
        useToast().success("Oops! Something went wrong. Please try again.");
      }
      this.showLoading = false;
    },
    goToSignInPage() {
      this.$router.push("/login");
    },
    async getResetPasswordToken() {
      this.showLoading = true;

      try {
        await getResetPasswordToken(this.tokenGetPhoneMobile).then((res) => {
          const { phoneMobile, resetPasswordToken } = res.data;
          this.phoneMobile = phoneMobile;
          this.tokenResetPassword = resetPasswordToken;
        });
        this.validTokenGetPhoneMobile = true;
      } catch (error) {
        useToast().error("The reset password link is expired or invalid, please try again.");
      }

      this.showLoading = false;
    },
  },
  created() {
    this.getResetPasswordToken();
  },
};
</script>
<style lang="scss" scoped>
.style-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  min-height: 100vh;
}

.style-header {
  color: $text-green;
  font-size: 18px;
}

.style-icon {
  width: 40%;
  height: 40%;
}
</style>
